import type { GetStaticProps } from "next";

import { getAllPartnerships } from "~/api/partnership/getAllPartnership";
import MembershipAbout from "~/components/membership/about";
import MembershipScrollWidget from "~/components/membership/scrollWidget";
import MembershipSelection from "~/components/membership/selection";
import SEO from "~/components/SEO";
import { PartnershipType } from "~/types/partnership/partnership.types";

interface Props {
  partnerships: PartnershipType[];
}

export const getStaticProps: GetStaticProps<Props> = async () => {
  const partnerships = await getAllPartnerships();
  return { props: { partnerships } };
};

const MembershipPage = ({ partnerships }: Props) => {
  return (
    <>
      <SEO
        title="Silencio - Adhésion"
        description="Être membre, c’est soutenir la création contemporaine internationale. Rejoignez une communauté d’artistes, de créatifs et d’entrepreneurs du monde entier."
        nofollow={false}
        noindex={false}
      />
      <MembershipScrollWidget />
      <MembershipAbout />
      <MembershipSelection partnerships={partnerships} />
    </>
  );
};

export default MembershipPage;
